import { render, staticRenderFns } from "./AccountAdd.vue?vue&type=template&id=d1a10424&scoped=true"
import script from "./AccountAdd.vue?vue&type=script&lang=js"
export * from "./AccountAdd.vue?vue&type=script&lang=js"
import style0 from "./AccountAdd.vue?vue&type=style&index=0&id=d1a10424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a10424",
  null
  
)

export default component.exports